import React, { createContext, useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export const ShopContext = createContext(null);

const ShopContextProvider = (props) => {
    const [cartItems, setCartItems] = useState([]);
    const [allProducts, setAllProducts] = useState([]);
    const [accountData, setAccountData] = useState(null);
    const [newProducts, setNewProducts] = useState([])

 
    //******** Get User *******//

    useEffect(() => {
        if (localStorage.getItem('Bearer')) {
            fetch(`${process.env.REACT_APP_URL}/api/user/account`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('Bearer')}`,
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => setAccountData(data)) 
                .catch((error) => console.error('Error fetching data:', error));
        }
    }, []); 

    //******** Get All Products *******//

    useEffect(() => {
        fetch(`${process.env.REACT_APP_URL}/api/products/all-products`)
            .then((response) => response.json())
            .then((data) => {
                setAllProducts(data);
            })
            .catch((error) => {
                console.error('Error fetching product data:', error);
            });
    }, []);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_URL}/api/products/new-products`)
            .then((response) => response.json())
            .then((data) => {
                setNewProducts(data);
            })
            .catch((error) => {
                console.error('Error fetching product data:', error);
            });
    }, []);

    //******** Cart Items *******//
    useEffect(() => {
        if (localStorage.getItem('Bearer')) {
            fetch(`${process.env.REACT_APP_URL}/api/cart/getcart`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('Bearer')}`,
                    'Content-Type': 'application/json',
                },

            })
                .then((response) => response.json())
                .then((data) => setCartItems(data));

                
        } else {
            const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
            setCartItems(guestCart);
        }
    }, []);

    //*************************************************************** FAVOURITES *******************************************************//

    const [favourites, setFavourites] = useState([]);

    
    const isFavourite = (productId) => favourites.some(fav => fav.id === productId);


    useEffect(() => {
        const fetchFavourites = async () => {
            try {
                const token = localStorage.getItem('Bearer');
                if (!token) {
                    console.error('Access token not found in local storage');
                    return;
                }
    
                const response = await axios.get(`${process.env.REACT_APP_URL}/api/favs/favs`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
    

                const fullFavourites = await Promise.all(
                    response.data.map(async (fav) => {
                        const productResponse = await axios.get(`${process.env.REACT_APP_URL}/api/products/${fav._id}`);
                        return productResponse.data;
                    })
                );
    
                setFavourites(fullFavourites);
            } catch (error) {
                console.error('Error fetching favourites:', error);
            }
        };
    
        fetchFavourites();
    }, []);
    

    const addToFavourites = async (productId) => {
        try {
            const token = localStorage.getItem('Bearer');
            if (!token) {
                console.log("Please login");
                return;
            }

            const productResponse = await axios.get(`${process.env.REACT_APP_URL}/api/products/${productId}`);
            const product = productResponse.data;
    
            setFavourites((prevFavourites) => [...prevFavourites, product]);

            await axios.post(`${process.env.REACT_APP_URL}/api/favs/add-fav`, { productId }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
        } catch (error) {
            console.error('Error adding product to favourites:', error);
            // Revert the optimistic update if the request fails
            setFavourites((prevFavourites) => prevFavourites.filter((fav) => fav._id !== productId));
        }
    };
    
    
    const removeFromFavourites = async (productId) => {
        try {
            const token = localStorage.getItem('Bearer');
            if (!token) {
                console.log("Please login");
                return;
            }
    
            setFavourites((prevFavourites) => prevFavourites.filter((fav) => fav.id !== productId));
    
            await axios.post(`${process.env.REACT_APP_URL}/api/favs/remove-fav`, { productId }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
        } catch (error) {
            console.error('Error removing product from favourites:', error);
            // Revert the optimistic update if the request fails
            setFavourites((prevFavourites) => [...prevFavourites, { id: productId }]);
        }
    };
    
    //******** Add to Cart *******//

    const addToCart = ({ itemId, personalisation }) => {
        if (!personalisation) {
            toast.warning("Reminder: You haven't added a personalized message.");
        }
    
        const newCartItem = {
            uId: uuidv4(),
            itemId,
            personalisation,
        };
    
        setCartItems((prev) => [...prev, newCartItem]);
    
        const token = localStorage.getItem('Bearer');
        if (token) {
            fetch(`${process.env.REACT_APP_URL}/api/cart/addtocart`, {
                method: "POST",
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newCartItem),
            })
                .then((response) => response.json())
                .then((data) => console.log(data))
                .catch((error) => console.error('Error adding item to cart:', error));
        } else {
            const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
            guestCart.push(newCartItem);
            localStorage.setItem('guestCart', JSON.stringify(guestCart));
        }
    };
    

    //******** Remove From Cart *******//
    const removeFromCart = ({ itemId, index }) => {
        setCartItems((prev) => {
            const newCartItems = [...prev];
            newCartItems.splice(index, 1);
            return newCartItems;
        });

        const token = localStorage.getItem('Bearer');
        if (token) {
            fetch(`${process.env.REACT_APP_URL}/api/cart/removefromcart`, {
                method: "POST",
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ itemId, index })
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                })
                .catch((error) => {
                    console.error('Error removing item from cart:', error);
                });
        } else {
            const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
            guestCart.splice(index, 1);
            localStorage.setItem('guestCart', JSON.stringify(guestCart));
        }
    };

    //******** Update Personalisation in Cart *******//
    const updatePersonalisationInCart = (props) => {
        const { index, itemId, personalisation } = props;
        const token = localStorage.getItem('Bearer');

        if (token) {
            fetch(`${process.env.REACT_APP_URL}/api/personalisation/add-personalisation`, {
                method: "POST",
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ index, itemId, personalisation })
            })
                .then((response) => response.json())
                .then((data) => console.log(data))
                .catch((error) => {
                    console.error('Error updating personalisation:', error);
                });
        }
    };

    

    //******** Get Cart Total *******//
    const getCartTotal = () => {
        const itemsArray = Array.isArray(cartItems) ? cartItems : Object.values(cartItems);
        const totalAmount = itemsArray.reduce((accumulator, item) => {
            if (item && item.itemId) {
                const itemInfo = allProducts.find(product => product._id === item.itemId);
                if (itemInfo && typeof itemInfo.price === 'number') {
                    return accumulator + itemInfo.price;
                } else {
                    console.error("ItemInfo is invalid or price is not a number:", itemInfo);
                }
            } else {
                console.error("Invalid item or missing itemId:", item);
            }
            return accumulator;
        }, 0);

        return totalAmount.toFixed(2);
    };

    //******** Items in Cart *******//
    const itemsInCart = () => {
        return cartItems.length;
    };



    const contextValue = {
        allProducts,
        cartItems,
        favourites,
        accountData,
        newProducts,
        isFavourite,
        addToFavourites,
        removeFromFavourites,
        addToCart,
        removeFromCart,
        getCartTotal,
        itemsInCart,
        updatePersonalisationInCart
    };

    return (
        <ShopContext.Provider value={contextValue}>
            {props.children}
        </ShopContext.Provider>
    );
};

export default ShopContextProvider;
